export interface ImageGalleryItem {
  url: string;
  alt: string;
  description?: string;
}
